import { SVGProps } from 'react';

const ClockArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v6l2 1m-1.663 8.994a10 10 0 1 1 9.588-8.767M22 18l-4 4-4-4m4 4v-8"
    />
  </svg>
);
export default ClockArrowDown;
